import React from "react";
import { ROLES } from "../config/roles";
import NewsCarousel from "../components/home/NewsCarousel";
import StandingsWidget from "../components/home/StandingsWidget";
import ClubRecentTenders from "../components/home/ClubRecentTenders";
import AgentRecentPitches from "../components/home/AgentRecentPitches";
import TransferWindow from "../components/home/TransferWindow";
import TransferPoints from "../components/home/TransferPoints";
import PlayerDashboard from "../components/home/PlayerDashboard";
import AgentDashboard from "../components/home/AgentDashboard";
import AgencyDashboard from "../components/home/AgencyDashboard";
import ClubPendingStaffInvites from "../components/home/ClubPendingStaffInvites";
import StaffPendingInvites from "../components/staff/StaffPendingInvites";
import CoachPendingInvites from "../components/coach/CoachPendingInvites";
import StaffPendingInvitesBanner from "../components/common/StaffPendingInvitesBanner";
import KycVerificationBanner from "../components/home/KycVerificationBanner";
import AgencyOverviewCard from "../components/home/AgencyOverviewCard";
import AgencyRecentActivityCard from "../components/home/AgencyRecentActivityCard";
import AgencyAgentsActivityTable from "../components/home/AgencyAgentsActivityTable";
import AgencyTopAgentsCard from "../components/home/AgencyTopAgentsCard";
import useHomeDashboard from "../hooks/useHomeDashboard";

const Home = () => {
  const {
    user,
    kycVerified,
    currentRole,
    recentActivity,
    recentLoading,
    agencyOverview,
    agencyActivities,
    agencyTopAgents,
    agencyPitches,
    agencyLoading,
    kycLoading,
    handleVerifyAccount,
    handleNavigateToPlayer,
    handleNavigateToClub,
    handleNavigateToAgent,
  } = useHomeDashboard();

  console.log("Home - Auth State:", { user, kycVerified, currentRole });

  const renderDashboard = () => {
    console.log("Home - Rendering Dashboard for role:", currentRole);
    switch (currentRole) {
      case ROLES.ClubAdmin:
        return (
          <>
            <ClubPendingStaffInvites />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8 mt-4">
              <ClubRecentTenders />
              <TransferWindow />
            </div>
          </>
        );

      case ROLES.Agent:
        return (
          <>
            <AgentDashboard user={user} kycVerified={kycVerified} />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8 mt-6">
              <AgentRecentPitches
                recentActivity={recentActivity}
                recentLoading={recentLoading}
              />
              <TransferWindow />
            </div>
          </>
        );

      case ROLES.Player:
        return <PlayerDashboard user={user} kycVerified={kycVerified} />;

      case ROLES.Staff:
        return (
          <>
            {/* TP-Coach-Mandate (F2): in-app respond surface for pending
                staff-mandate invitations — flag-gated inside the component. */}
            <StaffPendingInvitesBanner />
            <StaffPendingInvites />
          </>
        );

      case ROLES.Coach:
        return (
          <>
            {/* TP-Coach-Mandate (F2): see Staff case above. */}
            <StaffPendingInvitesBanner />
            <CoachPendingInvites />
          </>
        );

      case ROLES.AgencyAdmin:
        return (
          <>
            <AgencyDashboard user={user} kycVerified={kycVerified} />
            <div className="space-y-8 mt-6">
              {/* Agency Overview Section with Recent Activity */}
              <div className="flex flex-col lg:flex-row gap-6">
                <AgencyOverviewCard
                  agencyOverview={agencyOverview}
                  agencyLoading={agencyLoading}
                />
                <AgencyRecentActivityCard
                  agencyActivities={agencyActivities}
                  agencyLoading={agencyLoading}
                />
              </div>

              {/* Agents Activity Table */}
              <AgencyAgentsActivityTable
                agencyPitches={agencyPitches}
                agencyLoading={agencyLoading}
                onPlayerClick={handleNavigateToPlayer}
                onClubClick={handleNavigateToClub}
              />

              {/* Your Top Agents Section */}
              <AgencyTopAgentsCard
                agencyTopAgents={agencyTopAgents}
                agencyLoading={agencyLoading}
                onAgentClick={handleNavigateToAgent}
              />
            </div>
          </>
        );

      default:
        return null;
    }
  };

  return (
    <div className="min-h-screen bg-white pb-6">
      {!kycVerified && (
        <KycVerificationBanner
          currentRole={currentRole}
          kycLoading={kycLoading}
          onVerifyAccount={handleVerifyAccount}
        />
      )}
      <div className=" mx-auto px-4 md:px-10">
        {renderDashboard()}

        {currentRole !== ROLES.AgencyAdmin && (
          <>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-2 ">
              <NewsCarousel />
              {/* Cups (knockout brackets) are now selectable inside the
                  StandingsWidget dropdown and render their bracket in place of
                  the league table — no separate Pokal card. */}
              <StandingsWidget />
            </div>
            {currentRole !== ROLES.Player && (
              <div className="mt-8">
                <TransferPoints />
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Home;
